import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ category }) => {
  if (!category) return null;

  return (
    <Link 
      to={`/products?category=${category.id}`} 
      className="text-decoration-none"
    >
      <div className="card category-card h-100">
        <div className="position-relative overflow-hidden" style={{minHeight: '200px'}}>
          {category.image_url || category.image ? (
            <img 
              src={category.image_url || category.image} 
              alt={`Işıltı Saz Evi ${category.name} Kategorisi - Türk Müzik Enstrümanları`}
              className="card-img h-100"
              style={{objectFit: 'cover'}}
            />
          ) : (
            <div 
              className="d-flex align-items-center justify-content-center bg-gradient"
              style={{
                minHeight: '200px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              }}
            >
              <i className="bi bi-tags display-4 text-white"></i>
            </div>
          )}
          
          <div className="category-overlay">
            <div className="text-center text-white">
              <h4 className="fw-bold mb-2">{category.name}</h4>
              {category.category_count && (
                <p className="mb-0">
                  <i className="bi bi-box me-2"></i>
                  {category.category_count} Ürün
                </p>
              )}
            </div>
          </div>
        </div>
        
        <div className="card-body">
          <h5 className="card-title text-center mb-2">{category.name}</h5>
          {category.description && (
            <p className="card-text text-muted text-center small">
              {category.description.length > 80 
                ? `${category.description.substring(0, 80)}...` 
                : category.description
              }
            </p>
          )}
          
          <div className="text-center mt-3">
            <span className="btn btn-outline-primary btn-sm">
              <i className="bi bi-arrow-right me-2"></i>
              Ürünleri Gör
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CategoryCard;
